<template>
    <div class="callback-page">
        <p>Processing authentication...</p>
    </div>
</template>

<script>
export default {
    mounted() {
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        const error = urlParams.get('error');

        if (window.opener) {
            window.opener.postMessage({
                type: 'oidc-callback',
                code,
                error,
            }, window.location.origin);
        }
    },
};
</script>

<style>
.callback-page {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
}
</style>
